import React from 'react';

import { subscriber_directories_path } from '@routes';

interface OpenToSectionProps {
  openToParams: string;
  openToTitle: string;
  openToDesc: string;
}

const OpenToSection = ({ openToParams, openToTitle, openToDesc }: OpenToSectionProps) => (
  <div className="open-to-container">
    <a href={subscriber_directories_path({ open_to: openToParams })} className="open-header">
      {openToTitle}
    </a>
    <div className="open-subheader">{openToDesc}</div>
  </div>
);

export default OpenToSection;
